module.exports = __webpack_public_path__ + "media/recipes/23-3cc6b343.png";